import { render, staticRenderFns } from "./CaTransHelper.vue?vue&type=template&id=a0becbca"
import script from "./CaTransHelper.vue?vue&type=script&lang=js"
export * from "./CaTransHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports